import { merchantApi } from "@api";
import { IMerchant } from "@interfaces";
import { logout, resetMerchant, setMerchant, store } from "@redux";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";

const devServers = ["localhost", "liffdev", "192", "line"];

const getMerchant = async () => {
    try {
        const hostname = window.location.hostname;
        let prefix = hostname.split(".")[0];

        if (devServers.some((server) => prefix.includes(server))) {
            prefix = "channadecafe";
        }

        const res = await merchantApi.getMerchantNew();
        const merchant = res.data.data as IMerchant;
        if (!merchant.enableAccess) {
            store.dispatch(resetMerchant());
            store.dispatch(logout());
        }
        if (!merchant.themes) {
            store.dispatch(resetMerchant());
            store.dispatch(logout());
        } else {
            store.dispatch(setMerchant(merchant));
            CacheStore.setState({ isMerchantReady: true });
        }
        return merchant;
    } catch {
        console.log("error getting merchant");
        window.location.replace("/");
    }
};

export default getMerchant;
